
import { Component, Vue, Prop, Watch } from 'vue-facing-decorator'
import ChangeStock from './change-stock.vue'

@Component({
  components: { ChangeStock }
})
export default class extends Vue {

  @Watch("skuList")
  skuListWatcher() {
    this.$emit("update:modelValue", this.mresureList);
  }

  @Prop({
    default() {
      return []
    }
  })
  modelValue: any[];

  @Prop(
    {
      default() {
        return []
      }
    }
  )
  sku: any[];

  /** 编辑已有商品时为 true：库存只读，只能去商品列表用原子增减改 */
  @Prop({
    default() {
      return false;
    }
  })
  disabledStock: boolean;

  /**
   * 配了卡密发货的**规格**在 skuList 里的下标。
   * 那些行的库存由卡密池维护，后端 stock-operat 直接拒（'该规格的库存由卡密导入/作废维护'），
   * 所以连原子增减的入口都不给。
   *
   * 用下标而不是 skuId：新建商品时 SKU 还没落库、没有 id，
   * 而卡密规格在建的时候也不该让人手填库存。
   */
  @Prop({
    default() {
      return []
    }
  })
  lockedIndexes: number[];

  /**
   * 虚拟商品为 true：免运费，`weight` 不参与任何计算（order.service 里虚拟商品
   * 根本不进运费行），填了也没用，所以整列藏起来
   */
  @Prop({
    default() {
      return false;
    }
  })
  hideWeight: boolean;

  /** 虚拟商品才显示礼物栏（实物商品的礼物概念不存在） */
  @Prop({
    default() {
      return false;
    }
  })
  showGift: boolean;

  /** 每个规格的礼物摘要，下标和 modelValue（skuList）对齐 */
  @Prop({
    default() {
      return []
    }
  })
  giftTexts: string[];

  @Watch("sku")
  skuWatcher() {
    this.$emit("update:modelValue", this.mresureList);
  }

  created() {
    for (let i = 0; i < this.mresureList.length; i++) {
      Object.assign(this.mresureList[i], this.modelValue[i]);
    }
    this.$emit("update:modelValue", this.mresureList);
  }

  get listHash() {
    let res = {};
    for (let i = 0; i < this.modelValue.length; i++) {
      let item = this.modelValue[i];
      if (item._uuid) {
        res[item._uuid] = item;
      }
    }
    return res;
  }

  get mresureList() {
    if (!this.sku || this.sku.length == 0) return []
    let indexHash = {};
    this.computSku.map((item, index) => {
      indexHash[index] = { current: 0, item };
    });
    let valueList = [];
    while (true) {
      let goods = {
        _uuid: "",
        price: "",
        stock: "",
        weight: "",
        indexList: [],
      };
      for (let index in indexHash) {
        let item = indexHash[index];
        let spec = item.item;
        let current = item.current;
        let specList = spec.specList;
        goods._uuid += specList[current]._uuid;
        goods.indexList.push(current);
      }
      let hasNext = (() => {
        for (let i = this.computSku.length - 1; i >= 0; i--) {
          let nextIndex = indexHash[i].current + 1;
          let hasNext = this.computSku[i].specList[nextIndex];
          if (hasNext) {
            indexHash[i].current = nextIndex;
            return true;
          }
          indexHash[i].current = 0;
        }
        return false;
      })();
      if (this.listHash[goods._uuid]) {
        let imp = goods.indexList ? { indexList: goods.indexList } : {}
        valueList.push(
          Object.assign(this.listHash[goods._uuid], {
            ...goods,
            ...this.listHash[goods._uuid],
          }, imp)
        );
      } else {
        valueList.push(goods);
      }
      if (!hasNext) break;
    }
    return valueList;
  }
  get skuList() {
    let res = [];
    this.computSku.map((item) => {
      item.specList.map((citem) => {
        if (!citem._uuid) {
          citem._uuid = this.$getUUID();
        }
        res.push(citem);
      });
    });
    return res;
  }
  get computSku() {
    let res = [];
    for (let i = 0; i < this.sku.length; i++) {
      let item = this.sku[i];
      if (item.specList.length == 0) continue;
      res.push(item);
    }
    return res;
  }

  getName(item, row, index) {
    return item.specList[row.indexList[index]].name
  }

  arraySpanMethod({ rowIndex, columnIndex }) {
    if (columnIndex >= this.computSku.length) return [1, 1];
    if (columnIndex == 0) {
      let rowspan = 1;
      if (
        this.computSku[1] &&
        this.computSku[1].specList &&
        this.computSku[1].specList.length
      ) {
        rowspan *= this.computSku[1].specList.length;
      }
      if (
        this.computSku[2] &&
        this.computSku[2].specList &&
        this.computSku[2].specList.length
      ) {
        rowspan *= this.computSku[2].specList.length;
      }
      if (rowIndex % rowspan !== 0) {
        return {
          colspan: 1,
          rowspan: 0,
        };
      }
      return {
        rowspan,
        colspan: 1,
      };
    }
    if (columnIndex == 1) {
      let rowspan = 1;
      if (
        this.computSku[2] &&
        this.computSku[2].specList &&
        this.computSku[2].specList.length
      ) {
        rowspan *= this.computSku[2].specList.length;
      }
      if (rowIndex % rowspan !== 0) {
        return {
          colspan: 1,
          rowspan: 0,
        };
      }
      return {
        rowspan,
        colspan: 1,
      };
    }
    return [1, 1];
  }
  setValueMap = {
    price: { pattern: /^\d+(\.\d{1,2})?$/, message: "价格只能填写数字，最多两位小数" },
    stock: { pattern: /^\d+$/, message: "库存只能填写非负整数" },
    weight: { pattern: /^\d+(\.\d{1,2})?$/, message: "重量只能填写数字，最多两位小数" },
  }

  isStockLocked(index: number) {
    return this.lockedIndexes.indexOf(index) > -1;
  }

  /**
   * 库存是原子增减的，改完必须把后端返回的最新值回写这一行：
   * 不回写的话，用户接着点「保存」，整单提交会用表单里那个旧值把刚改的库存盖回去
   */
  stockChangeEvent(data) {    if (!data) return;
    let sku = this.modelValue.find((item) => item.id == data.id);
    if (sku) sku.stock = data.stock;
  }

  async setValue(key) {
    let config = this.setValueMap[key];
    let data = await this.$prompt('提示', {
      title: "请输入批量设置值",
      inputPattern: config.pattern,
      inputErrorMessage: config.message,
    });
    this.modelValue.map(function (item) {
      item[key] = data.value;
    });
  }
}
